/**
 * @module store
 */
import store from '../store'

/**
 * @const
 * @module utils/endpoints
 */
import {AUTH_URL} from '../utils/endpoints'

/**
 * Metodo que verifica si el cliente está autenticado antes de entrar a una ruta
 * @param to
 * @param from
 * @param next
 * @returns {Promise<void>}
 */
function requireAuth(to, from, next) {
  store.dispatch('saveFromRoute', from)
  // console.log('TO: ', to.path)
  if (!store.getters['auth/roleLoaded']) store.dispatch('auth/setRole')
  const role = store.getters['auth/role']
  const adminRole = store.getters['auth/adminRole']
  const opera = store.getters['auth/opera']
  // console.log('ROLE: ', role)
  // console.log('Opera: ', opera)
  const hasOnlyMobileRole = store.getters['auth/hasOnlyMobileRole']

  // Check if the user has only a mobile role
  if (hasOnlyMobileRole) window.location.replace(`${AUTH_URL}?redirectUri=${window.location.origin}`)

  if (store.dispatch('auth/isAuthenticated')) {
    const roleRestriction = to.meta.restriction
    // console.log('ROL RESTRICTION', roleRestriction)
    let restriction = false
    if (roleRestriction.length > 0) {
      for (let i = 0; i < roleRestriction.length; i++) {
        const element = roleRestriction[i]
        // SUPER OPERA
        // console.log('ELEMENT OPERA', element, opera)
        if (element === 23 && opera === 0) {
          // console.log('SUPER!!!')
          restriction = true
          if (restriction) break
        }

        restriction = role.some(item => item === element)
        if (restriction) break
      }
    }

    // console.log('ADMIN ROLE: ', adminRole, restriction)

    if (restriction && adminRole === null) {
      if (
        opera === 0 &&
        (
          to.path === '/reports' ||
          to.path === '/k-p-i'
        )
      ) next()
      else if (
        opera === 0 &&
        to.path === '/missions/services' &&
        role[0] !== 23
      ) next()
      else next('/')
    } else {
      // if (to.path === '/geofences' && adminRole !== 500) next('/')
      // else next()
      next()
    }
  } else {
    window.location.replace(`${AUTH_URL}?redirectUri=${window.location.origin}`)
  }
}

export default requireAuth



// WEBPACK FOOTER //
// ./src/router/authMiddleware.js